<template>
  <div class="list-page">
    <div class="header">
      <header-back @back="onClickBack">
        <template #center>
          <choose-type
            v-if="typeOptions.length"
            :value="type"
            :options="typeOptions"
            @change="handleChangeType"
          />
        </template>
        <!-- <template #right>
          <div
            class="operate-set"
            @click="openOperate"
          >
            <i class="iconfont iconicon-test32" />
          </div>
        </template> -->
      </header-back>
    </div>
    <operate-set />
    <div
      v-if="filterStr"
      class="filter-num"
    >
      {{ selectedTxt[0] }}{{ pagination.total }}{{ selectedTxt[1] }}{{ pagination.allCount }}{{ selectedTxt[2] }}
      <i
        class="clear-filter-btn"
        @click="clearFilter"
      >{{ $t('message["736"]') }}</i>
    </div>
    <my-list
      ref="myList"
      :from="from"
      :type="type"
      :params-type="_type"
    />
    <filter-form
      ref="filterModal"
      :visible.sync="showFilterModal"
      :from="from"
      :type="type"
      :params-type="_type"
      class="filter-modal"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

import { base64ToJson } from '@/lib/utils'
import eventBus from '@/lib/eventBus'
import HeaderBack from '@/components/mobile/HeaderBack.vue'
import ChooseType from '@/components/mobile/ChooseType'
import OperateSet from './Sort'
import FilterForm from './Filter'
import MyList from './List'

export default {
  components: {
    HeaderBack,
    ChooseType,
    OperateSet,
    FilterForm,
    MyList
  },
  data () {
    return {
      code: '',
      showFilterModal: false
      // sortVisible: false
    }
  },
  computed: {
    ...mapState(['menuDatas']),
    ...mapState('inquery/listData', [
      'pagination'
    ]),
    ...mapState('inquery/filterData', ['filterStr']),

    permissionMenuList () {
      const { permissionMenuList = [] } = this.menuDatas || {}
      return permissionMenuList
    },
    query () {
      return this.$route.query || {}
    },
    from () {
      return this.query.from || 'all'
    },
    type () {
      return this.query.type
    },
    _type () {
      let data = ''
      if (this.from === 'all') {
        switch (this.type) {
          // 管理员/负责人
          case 'inquiry-manager-all':
            data = 0
            break
          case 'inquiry-manager-followup':
            data = 1
            break
          case 'inquiry-manager-need-allocate':
            data = 2
            break
          case 'inquiry-manager-need-assign':
            data = 3
            break
          case 'inquiry-manager-share':
            data = 4
            break
          case 'inquiry-manager-archive':
            data = 5
            break
          // 主管、组长
          case 'inquiry-dev':
            data = 'dev'
            break
          case 'inquiry-add':
            data = 'input'
            break
          case 'inquiry-audit':
            data = 'audit'
            break
          case 'inquiry-followup':
            data = 'follow'
            break
          case 'inquiry-share':
            data = 'share'
            break
          case 'inquiry-archive':
            data = 'archive'
            break
        }
      }
      if (this.from === 'my') {
        switch (this.type) {
          case 'inquiry-dev':
            data = 'dev'
            break
          case 'inquiry-add':
            data = 'input'
            break
          case 'inquiry-audit':
            data = 'audit'
            break
          case 'inquiry-followup':
            data = 'follow'
            break
          case 'inquiry-share':
            data = 'share'
            break
        }
      }

      return data
    },
    typeOptions () {
      let options = []
      let childArr = {}
      if (this.from === 'all') {
        const { child = {} } = this.permissionMenuList['inquiry-all'] || {}
        childArr = child
      } else {
        const { child = {} } = this.permissionMenuList['inquiry-mine'] || {}
        childArr = child
      }
      for (let k in childArr) {
        let obj = {}
        obj.key = k
        obj.name = childArr[k].name
        obj.state = childArr[k].state
        if (obj.state) {
          options.push(obj)
        }
      }
      return options
    },
    selectedTxt () {
      return this.$t('message["1470"]').split('|')
    }
  },
  created () {
    const { filter, code } = this.$route.query
    const searchs = filter ? base64ToJson(filter) : {}
    this.setSearchs(searchs)
    this.setCode(code ? decodeURIComponent(code) : '')

    this.permissionMenu()
    eventBus.$on('showFilter', this.toggleFilter)
  },
  destroyed () {
    this.CLEAR_LIST_DATA()
  },
  methods: {
    ...mapActions(['permissionMenu']),
    ...mapActions('inquery/filterData', ['setFilterResult', 'setFilterStr']),
    ...mapMutations('inquery/listData', ['setCode', 'setSearchs', 'CLEAR_LIST_DATA', 'SET_TABLE_SORT']),

    onClickBack () {
      this.$router.push({
        name: 'ProjectIndex'
      })
      this.SET_TABLE_SORT({
        tableSort: {
          sortfieldtype: '',
          sortkey: 'code',
          sorttype: 2
        },
        sorter: {}
      })
      this.setFilterStr('')
      this.setFilterResult({})
    },
    onSearch () {
      const { code, query } = this
      this.$router.push({
        name: 'InqueryList',
        query: {
          ...query,
          code: encodeURIComponent(code)
        }
      })
      this.$refs.myList.fetchData({
        code
      })
    },
    handleChangeType (type) {
      this.$router.push({
        name: 'InqueryList',
        query: {
          from: this.from,
          type: type
        }
      })
    },
    onReset () {
      this.code = ''
    },
    toggleFilter (val) {
      this.showFilterModal = val
    },
    clearFilter () {
      this.$refs.filterModal && this.$refs.filterModal.reset()
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-num {
  // height: 32px;
  line-height: 32px;
  margin: 12px 28px 0;
  text-align: center;
  background-color: #e8f4ff;
  border: solid 1px #4ca0f2;
  border-radius: 2px;
  .clear-filter-btn {
    margin-left: 12px;
    font-style: normal;
    cursor: pointer;
    color: #5077aa;
    white-space: nowrap;
  }
}
.list-page {
  height: 100%;
  overflow: hidden;
  background-color: #f5f5f5;
}
/* .operate-set {} */
.filter-set {
  // color: #d6d6d6;
  .icon-filter {
    margin-right: 5px;
  }
}
</style>
